(function (window, undefined) {
    'use strict';

    var app,
        fn = {},
        _fn = {},
        cf = {
            MARKER_IMAGE_DIR: '//aurora4d.jp/wp-content/themes/aurora4d/assets/images/',
            ZOOM_DEFAULT: 2,
            ZOOM_FULLSCREEN: 3,
        },
        map,
        markers = [],
        console,
        google,
        manager,
        mapCanvas;

    fn.init = function () {
        var mapOpt;

        // window.console.log('map.init called.');
        console = window.console;
        google = window.google;
        manager = window.timelinemap.manager;

        mapCanvas = window.document.getElementById('js-map-canvas');

        mapOpt = {
            lat: 50,
            lng: -100,
            zoom: cf.ZOOM_DEFAULT
        };

        map = new google.maps.Map(mapCanvas, {
            center: {
                lat: mapOpt.lat,
                lng: mapOpt.lng
            },
            zoom: mapOpt.zoom
        });
    };

    fn.initMarker = function () {
        var m;

        for (m in markers) {
            markers[m].setMap(null);
        }
    };

    fn.drawMarker = function (data, current_id) {
        var slide,
            icon = {},
            zIndex,
            currentLatLng = null,
            marker,
            latLng;

        markers = [];

        for (slide in data) {
            if (data[slide].map.latitude === '' || data[slide].map.longitude === '') {
                continue;
            }

            latLng = new google.maps.LatLng(data[slide].map.latitude, data[slide].map.longitude);

            if (current_id === data[slide].unique_id) {
                icon = {
                    url: cf.MARKER_IMAGE_DIR + 'current-marker.png',
                    scaledSize: new google.maps.Size(30, 40)
                };
                zIndex = 1;
                currentLatLng = latLng;
            } else {
                icon = {
                    url: cf.MARKER_IMAGE_DIR + 'default-marker.png',
                    scaledSize: new google.maps.Size(30, 40)
                };
                zIndex = 0;
            }

            marker = new google.maps.Marker({
                position: latLng,
                icon: icon,
                zIndex: zIndex
            });

            markers.push(marker);
            marker.setMap(map);
            _fn.addEventMarker(marker, data[slide].unique_id);
        }
        if (currentLatLng !== null) {
            // mapの中心を赤いマーカーの座標に合わせる
            map.setCenter(currentLatLng);
            // mapを拡大
            // map.setZoom(6);
        } else {
            // mapを元の縮尺に戻す
            // map.setZoom(2);
        }
    };

    _fn.addEventMarker = function (marker, id) {
        marker.addListener('click', function () {
            manager.onClickMarker(id);
        });
    };

    fn.getCenter = function () {
        return map.getCenter();
    };

    fn.resize = function (center, isFullscreen) {
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
        if (isFullscreen) {
            map.setZoom(cf.ZOOM_FULLSCREEN);
        } else {
            map.setZoom(cf.ZOOM_DEFAULT);
        }
    };

    app = function (prop) {
        var app,
            m;

        app = {};
        for (m in fn) {
            app[m] = fn[m];
        }
        return app;
    };

    window.timelinemap = window.timelinemap || {};
    window.timelinemap.fn = window.timelinemap.fn || {};
    window.timelinemap.fn.map = app;

}(this));
